import React, { useState, useEffect, useContext } from "react";
import Labeled from "common/Labeled";
import ActionsContext from "common/ActionsContext";
import ChoiceOrValue from "common/ChoiceOrValue";

const doesNothing = () => {};

const waitFor = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

export const protocols = [
  { number: "1", name: "icmp" },
  { number: "6", name: "tcp" },
  { number: "17", name: "udp" },
  { number: "47", name: "gre" },
  { number: "89", name: "ospf" },
];

const protocolAsOption = ({ number, name }) => ({
  value: name,
  label: `${name.toUpperCase()} (${number})`,
});

const options = [
  { value: "any", label: "Any" }, //selected class="hideWhenIPV4IPV6"
  ...protocols.map(protocolAsOption),
  { value: "spec", label: "Specify Protocol Number:" },
];

const mayHideAny = (hide) =>
  hide === false ? () => true : ({ value }) => value !== "any";

const wholeProtocol = new Set(["0.0.0.0/0", "::/0"]);

export const ProtocolInput = ({
  name,
  defaultSelectValue = "any",
  defaultValue = "",
  onChange = doesNothing,
}) => {
  const actions = useContext(ActionsContext);
  const [hideAny, setHideAny] = useState(false);

  useEffect(
    () =>
      actions.recv("address-changed", (address) =>
        setHideAny(wholeProtocol.has(address))
      ),
    []
  );

  const reportAndChange = (protocol) => {
    waitFor(100).then(() => actions.send("protocol-changed", protocol));
    onChange(protocol);
  };

  return (
    <ChoiceOrValue
      name={name}
      options={options.filter(mayHideAny(hideAny))}
      defaultValue={defaultValue}
      defaultSelectValue={defaultValue === "" ? defaultSelectValue : "spec"}
      onChange={reportAndChange}
      type="number"
      min={0}
      max={255}
      hideArrows={true}
    />
  );
};

export const LabeledProtocolInput = ({ ...settings }) => (
  <Labeled {...settings}>
    <div className="margin-l-10 flex-100">
      <ProtocolInput {...settings} />
    </div>
  </Labeled>
);

export default LabeledProtocolInput;
